<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-column gap-2 mb-3">
      <span class="h5"> {{ title }}</span>
      <span v-if="description" class="fs-sm text-description">{{
        description
      }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped></style>
